import React from 'react';

import {
  AccountManager,
  NotificationManager,
  printMissingConfigError,
  ResponsibleApi,
  SiteConfigManager,
  useAuthorizationEffect,
  useLabel,
} from '@atlas/core';
import { BasePopup, Button, Label, TranslateWithLinks } from '@atlas/ui';

export default function RealityCheckPopup(notification) {
  const { id, message, title } = notification;

  const handleLogoutButtonClick = React.useCallback(() => {
    NotificationManager.removeNotification(id);
    AccountManager.logout();
  }, [id]);

  const handleContinueButtonClick = React.useCallback(() => {
    NotificationManager.removeNotification(id);
    ResponsibleApi.realityCheckPing();
  }, [id]);

  const realityCheckPopupLink = SiteConfigManager.getConfig(
    'config.config.links.reality_check_popup_link',
  );

  if (!realityCheckPopupLink) {
    printMissingConfigError('config.config.links.reality_check_popup_link');
  }

  useAuthorizationEffect(authorization => {
    if (!authorization) {
      NotificationManager.removeNotification(id);
    }
  });

  const realityCheckLabel = useLabel(message, { link: realityCheckPopupLink });

  return (
    <BasePopup className="reality-check-popup">
      <div className="popup__footer">
        <div className="popup__content">
          {title && <Label className="popup__title" message={title} />}
          {realityCheckLabel && (
            <div className="popup__text">
              <TranslateWithLinks translate={realityCheckLabel} />
            </div>
          )}
        </div>
        <div className="popup__buttons">
          <Button label="signout" onClick={handleLogoutButtonClick} size="big" type="secondary" />

          <Button label="continue" onClick={handleContinueButtonClick} size="big" type="primary" />
        </div>
      </div>
    </BasePopup>
  );
}
